module.exports = __webpack_public_path__ + "static/media/exhibitions.d1385877.csv";